var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel"
  }, [_vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('div', {
    key: "mortgage-".concat(_vm.idOfMortgage)
  }, [_c('progress-bar-hypoteky', {
    on: {
      "switch-to": function switchTo($event) {
        return _vm.switchComponent($event);
      }
    }
  }), _c(_vm.component, {
    tag: "component",
    attrs: {
      "mortgage": _vm.mortgage,
      "applicant": _vm.applicant,
      "co-applicant": _vm.coApplicant
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }